/* eslint-disable react/jsx-no-duplicate-props */
import React, { useState } from 'react'
import { useField } from 'formik'
import { TextField, InputAdornment, IconButton } from '@mui/material'
import { VisibilityOff, Visibility } from '@mui/icons-material'

// Input field component, with label, input and error handler
function FormInputField({ label, autoComplete = false, ...props }) {
  const [field, meta] = useField(props)
  const isInvalid = !!meta.touched && !!meta.error
  const [showPassword, setShowPassword] = useState(false)
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleMouseDownPassword = (event) => {
    event.preventDefault()
  }

  return (
    <div>
      <label
        className='block text-gray-700 text-sm font-bold pt-2 pb-1'
        htmlFor={props.id || props.name}
      >
        {label}
      </label>
      <TextField
        className='z-0'
        fullWidth
        error={isInvalid}
        {...field}
        {...props}
        {...(!autoComplete && {
          inputProps: { form: { autoComplete: 'off' } },
        })}
        value={field.value === undefined ? '' : field.value}
        type={showPassword ? 'text' : props.type}
        InputProps={
          props.name.toLowerCase().includes('password')
            ? {
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge='end'
                    >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }
            : {}
        }
      />
      {isInvalid && <div className='text-red-500 text-sm'>{meta.error}</div>}
    </div>
  )
}

export default FormInputField
